<template>
  <v-dialog
    v-model="internalVisible"
    max-width="520"
    persistent
  >
    <v-card>
      <!-- Card Title -->
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>
      <!-- Card Content -->
      <v-card-text>
        <div class="d-flex align-center mb-6">
          <img
            width="60"
            :src="photoUrls.length ? $convertImgix(`${photoUrls[0]}?w=128`) : noPicture"
            alt="product"
            class="mr-4 rounded"
          />
          <div>
            <p class="font-weight-medium mb-1">
              {{ name }}
            </p>
            <p class="text-body-2 mb-1">
              {{ code }}
            </p>
            <p class="text-body-2 mb-1">
              {{ colorSize }}
            </p>
            <p class="text-body-2 mb-1">
              COLLECTION : {{ collection.toUpperCase() }}
            </p>
            <p class="text-body-2 mb-1">
              LOCATION : {{ location.name }}
            </p>
            <p class="text-body-2 mb-1">
              จำนวนปัจจุบัน {{ qty | showNumberFormat() }}
            </p>
          </div>
        </div>
        <v-text-field
          v-model="inputValue"
          label="Enter number"
          type="number"
          outlined
          dense
          hide-details
          @keypress="onlyNumber"
        />
      </v-card-text>

      <v-divider />

      <!-- Card Actions -->
      <v-card-actions class="justify-end">
        <v-btn
          text
          color="grey"
          @click="cancel"
        >
          ยกเลิก
        </v-btn>
        <v-btn
          color="secondary"
          @click="confirm"
        >
          บันทึก
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import NoPicture from '@/assets/image/no_picture_available.png'

export default {
  name: 'AdjustmentQtyDialog',
  props: {
    adjustmentData: {
      type: Object,
      default: () => {}
    },
    location: {
      type: Object,
      default: () => {}
    },
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Enter Number'
    }
  },
  data () {
    return {
      noPicture: NoPicture,
      inputValue: this.adjustmentData.qty,
      internalVisible: this.visible
    }
  },
  computed: {
    photoUrls () {
      return this.adjustmentData.product.photoUrls || []
    },
    name () {
      return this.adjustmentData.name || []
    },
    code () {
      return this.adjustmentData.code || []
    },
    collection () {
      return this.adjustmentData.collectionName || '-'
    },
    colorSize () {
      return `${this.adjustmentData.sku.color.name} - ${this.adjustmentData.sku.size.name}`.toUpperCase()
    },
    qty () {
      return this.adjustmentData.qty
    }
  },
  watch: {
    adjustmentData (val) {
      this.inputValue = val.qty
    },
    visible (val) {
      this.internalVisible = val
    },
    internalVisible (val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    onlyNumber (e) {
      // block non-digits, block minus, block dot
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault()
      }
    },
    confirm () {
      // eslint-disable-next-line radix
      const val = parseInt(this.inputValue, 10) || 0
      this.$emit('confirm', val)
      this.internalVisible = false
    },
    cancel () {
      this.$emit('cancel')
      this.internalVisible = false
    }
  }
}
</script>
